import React, { useEffect, useState } from 'react'
import { Alert, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { urlObtenerInformacionEmisionFutura } from '../../constants/urls';
import { Checkbox } from "react-inputs-validation";
import DatePicker from "react-datepicker";
import moment from 'moment';

const EmisionRetroactiva = ({
    ramo,
    setLoading,
    ramfecFuturo,
    setRamfecFuturo,
    ramfecRetroactividad,
    setRamfecRetroactividad,
    requiereEmision,
    setRequiereEmision,
    vigenciaRetroactiva,
    setVigenciaRetroactiva,
    errorVigenciaRetroactiva,
    setErrorVigenciaRetroactiva,
    mensaje,
    bloqueoPorRiesgo = false,
    setBloqueoPorRiesgo = ()=>{}
}) => {

    const [mensajeErrorNoSeleccionado, setMensajeErrorNoSeleccionado] = useState('Por favor seleccionar una respuesta')
    const [preguntaNoSeleccionada, setPreguntaNoSeleccionada] = useState(false)
    const [valuePregunta, setValuePregunta] = useState(null)
    const [mensajeErrorPregunta, setMensajeErrorPregunta] = useState('No se puede cotizar comuniquese con AIG.')
    const [mostrarRiesgo, setMostrarRiesgo] = useState(false)
    const [mensajeRetroactividad, setMensajeRetroactividad] = useState('Su solicitud de vigencia retroactiva o futura requiere el análisis y la autorización del área de suscripción de AIG, puede revisar el estado en el “Administrador del portal”');
    const [pregunta, setPregunta] = useState('1. ¿Se confirma que los asegurados declarados en la facturación inicial, no presentan siniestros a la fecha?')

    const [aplicaRiesgo, setAplicaRiesgo] = useState(false)


    useEffect(() => {
        obtenerValores()

    }, [])

    const obtenerValores = async () => {

        setLoading(true)
        var url = `${urlObtenerInformacionEmisionFutura}${ramo}`;
        try {
            const response = await fetch(url)
            const json = await response.json()
            if (json.transaccion) {
                console.log('riesgo', json)
                setRamfecFuturo(json.retroactivafutura.ramfecFuturo)
                setRamfecRetroactividad(json.retroactivafutura.ramfecRetroactividad)
                setAplicaRiesgo(json.retroactivafutura.ramfecValidarSiniestralidad)
                if (json.msjAdvertenciaEmisionRetroactiva) setMensajeRetroactividad(json.msjAdvertenciaEmisionRetroactiva);
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }

    }
    return (
        <Card>
            <CardBody>
                <Row>
                    <Col lg={10} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>
                            {mensaje}
                        </h5>
                    </Col>
                    <Col lg={1} md={6} sm={6} xs={12}>
                        <Checkbox
                            id={"agreement"} // Optional.[String].Default: "".  Input ID.
                            name={"agreement"} // Optional.[String].Default: "". Input name
                            classNameInputBox={'check-uber-light'}
                            value={requiereEmision} // Required.[String].Default: "".
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            checked={requiereEmision} // Required.[Bool].Default: false.
                            onChange={(requiereEmision, e) => {

                                setRequiereEmision(requiereEmision)

                                //console.log(e);
                            }} // Required.[Func].Default: () => {}. Will return the value.
                            validationOption={{
                                name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            }}
                        />
                    </Col>


                </Row>

                {requiereEmision &&

                    <div>
                        <Row>
                            <Col lg={8} md={6} sm={6} xs={12}>

                                {`Fecha inicio de vigencia`}

                            </Col>
                            <Col lg={4} md={6} sm={6} xs={12}>

                                <DatePicker

                                    dateFormat="dd/MM/yyyy"
                                    isClearable={false}
                                    selected={new Date(vigenciaRetroactiva)}
                                    onChange={(valor) => {

                                        let continuar = true
                                        var diferenciaDias = moment(new Date(valor)).diff(new Date(), 'days');
                                        if (diferenciaDias >= (parseInt(ramfecRetroactividad) * -1) && diferenciaDias < parseInt(ramfecFuturo)) {
                                            setErrorVigenciaRetroactiva(false)
                                        } else {
                                            setErrorVigenciaRetroactiva(true)
                                        }

                                        if ((aplicaRiesgo && diferenciaDias < 0 )) {
                                            setMostrarRiesgo(true)
                                            if (valuePregunta == null) {
                                                continuar = false
                                                setPreguntaNoSeleccionada(true)
                                                setBloqueoPorRiesgo(true)
                                            }
                            
                                            if (valuePregunta == 'no') {
                                                continuar = false
                                                setBloqueoPorRiesgo(true)
                            
                                            }
                                        } else {
                                            setMostrarRiesgo(false)
                                            setBloqueoPorRiesgo(false)
                            
                                        }
                                        setVigenciaRetroactiva(valor);
                                    }}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control"

                                />

                                {errorVigenciaRetroactiva ?
                                    <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">
                                        {`Debe seleccionar una fecha entre ${moment(new Date()).add(-parseInt(ramfecRetroactividad), 'days').format('DD/MM/yyyy')} - ${moment(new Date()).add(parseInt(ramfecFuturo), 'days').format('DD/MM/yyyy')}`}
                                    </div> : null
                                }

                            </Col>

                        </Row>

                        <Alert color='warning'>
                            {mensajeRetroactividad}
                        </Alert>

                        {(aplicaRiesgo && mostrarRiesgo) &&
                            <Row className="menu-superior-pantallas-grandes">
                                <Col lg={11} md={12} sm={12} xs={12} className="div-align-center">
                                    <Card className="">
                                        <CardHeader >
                                            Validación de siniestralidad
                                        </CardHeader>
                                        <CardBody>
                                            <Row >
                                                <Col lg={4} md={4} sm={12} xs={12} >
                                                    <p style={{ fontWeight: "200", textAling: "justify" }}>{'¿Se confirma que los asegurados declarados en la facturación inicial, no presentan siniestros a la fecha?'}</p>
                                                </Col>
                                                <Col lg={4} md={4} sm={12} xs={12}  >
                                                    <Row>
                                                        <Col md={6} sm={6} xs={6} >
                                                            <Checkbox
                                                                id={`preguntaSI`} // Optional.[String].Default: "".  Input ID.
                                                                name={`preguntaSI`}
                                                                //value={factotal} // Required.[String].Default: "".
                                                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                                checked={valuePregunta == 'si'} // Required.[Bool].Default: false.
                                                                onChange={(res, e) => {


                                                                    setValuePregunta('si')
                                                                    setPreguntaNoSeleccionada(false)
                                                                    setBloqueoPorRiesgo(false)


                                                                }}
                                                                labelHtml={
                                                                    <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                                                                        SI
                                                                    </div>
                                                                } // Required.[Html].Default: none.
                                                                validationOption={{
                                                                    name: 'preguntaSI', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                                                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col md={6} sm={6} xs={6} >
                                                            <Checkbox
                                                                id={`preguntaNO`} // Optional.[String].Default: "".  Input ID.
                                                                name={`preguntaNO`}
                                                                //value={factotal} // Required.[String].Default: "".
                                                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                                checked={valuePregunta == 'no'} // Required.[Bool].Default: false.
                                                                onChange={(res, e) => {
                                                                    setValuePregunta('no')
                                                                    setPreguntaNoSeleccionada(false)
                                                                    setBloqueoPorRiesgo(true)
                                                                }}
                                                                labelHtml={
                                                                    <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                                                                        NO
                                                                    </div>
                                                                } // Required.[Html].Default: none.
                                                                validationOption={{
                                                                    name: 'preguntaNO', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                                                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    {preguntaNoSeleccionada &&
                                                        <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">
                                                            {mensajeErrorNoSeleccionado}
                                                        </div>
                                                    }

                                                </Col>
                                            </Row>
                                            {valuePregunta == 'no' &&
                                                <Row  >
                                                    <Col md={10} sm={12} className="div-align-center">
                                                        <Alert color="danger">
                                                            <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i></p>
                                                            <p style={{ textAlign: "center" }}>{mensajeErrorPregunta}</p>

                                                        </Alert>
                                                    </Col>
                                                </Row>
                                            }


                                        </CardBody>
                                    </Card>

                                </Col>
                            </Row>
                        }


                    </div>
                }



            </CardBody>
        </Card>
    )
}

export default EmisionRetroactiva;